import PaymentHint from './PaymentHint';

export default PaymentHint;
